var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCheck = function SvgCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Thick",
    transform: "translate(-1566 -465)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_942",
    "data-name": "Path 942",
    transform: "translate(1566 465)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,0H47a4,4,0,0,1,4,4V47a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4 3 C 3.448600769042969 3 3 3.448600769042969 3 4 L 3 47 C 3 47.55139923095703 3.448600769042969 48 4 48 L 47 48 C 47.55139923095703 48 48 47.55139923095703 48 47 L 48 4 C 48 3.448600769042969 47.55139923095703 3 47 3 L 4 3 M 4 0 L 47 0 C 49.20914077758789 0 51 1.790859222412109 51 4 L 51 47 C 51 49.20914077758789 49.20914077758789 51 47 51 L 4 51 C 1.790859222412109 51 0 49.20914077758789 0 47 L 0 4 C 0 1.790859222412109 1.790859222412109 0 4 0 Z",
    stroke: "none",
    fill: "#06016c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_941",
    "data-name": "Path 941",
    d: "M11.09,18.426,0,7.336,3.583,3.754,11.09,11.09,22.18,0l3.583,3.583Z",
    transform: "translate(1577.943 481.877)",
    fill: "#2699fb"
  }))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check.0f885118.svg";
export { ForwardRef as ReactComponent };